export const mr = {
  // Navigation (Marathi)
  explore: 'एक्सप्लोर',
  search: 'शोध',
  create: 'पोस्ट तयार करा',
  messages: 'संदेश',
  notifications: 'सूचना',
  settings: 'सेटिंग्ज',
  profile: 'प्रोफाइल',
  logout: 'लॉग आउट',
  home: 'होम',
  
  // Authentication
  signin: 'साइन इन',
  signup: 'साइन अप',
  login: 'लॉगिन',
  register: 'नोंदणी',
  email: 'ईमेल',
  password: 'पासवर्ड',
  confirmPassword: 'पासवर्ड पुष्टी करा',
  firstName: 'पहिले नाव',
  lastName: 'आडनाव',
  forgotPassword: 'पासवर्ड विसरलात?',
  alreadyHaveAccount: 'आधीच खाते आहे? साइन इन करा',
  dontHaveAccount: 'खाते नाही? साइन अप करा',
  
  // Posts & Content
  recent: 'अलीकडील',
  trending: 'ट्रेंडिंग',
  popular: 'लोकप्रिय',
  like: 'आवडले',
  likes: 'आवडले',
  comment: 'टिप्पणी',
  comments: 'टिप्पण्या',
  share: 'शेअर',
  delete: 'हटवा',
  edit: 'संपादित करा',
  post: 'पोस्ट',
  posts: 'पोस्ट्स',
  title: 'शीर्षक',
  content: 'सामग्री',
  tags: 'टॅग्ज',
  noBlogsFound: 'कोणतेही ब्लॉग सापडले नाहीत। दुसरे काहीतरी शोधण्याचा प्रयत्न करा किंवा पहिले तयार करा!',
  
  // AI Assistant
  quickActions: 'द्रुत क्रिया',
  writeCaption: 'कॅप्शन लिहा',
  suggestTopics: 'विषय सुचवा',
  improveContent: 'सामग्री सुधारा',
  creativeIdeas: 'सर्जनशील कल्पना',
  clearChat: 'चॅट साफ करा',
  aiWritingAssistant: 'AI लेखन सहाय्यक',
  poweredByGroq: 'GROQ AI द्वारे समर्थित',
  aiGreeting: 'नमस्कार! मी तुमचा AI लेखन सहाय्यक आहे। मी तुम्हाला आकर्षक सामग्री तयार करण्यात, कॅप्शन लिहिण्यात, पोस्ट विषय सुचवण्यात आणि तुमचे लेखन सुधारण्यात मदत करू शकतो। आज तुम्ही कशावर काम करू इच्छिता?',
  askMeToHelp: 'सामग्री, कॅप्शन, विषय किंवा लेखनासाठी मला मदतीसाठी विचारा...',
  aiThinking: 'AI विचार करत आहे...',
  
  // Chat & Messages
  chat: 'चॅट',
  noConversationsYet: 'अद्याप संभाषणे नाहीत',
  ideafluxChat: 'IdeaFlux चॅट',
  typeMessage: 'संदेश टाइप करा...',
  sendMessage: 'संदेश पाठवा',
  connectingToChat: 'चॅटशी कनेक्ट होत आहे...',
  
  // Notifications
  noNotificationsYet: 'अद्याप सूचना नाहीत।',
  markAllRead: 'सर्व वाचलेले म्हणून चिन्हांकित करा',
  clearAll: 'सर्व साफ करा',
  
  // Settings
  accountSettings: 'खाते सेटिंग्ज',
  displayName: 'प्रदर्शन नाव',
  emailAddress: 'ईमेल पत्ता',
  languagePreference: 'भाषा प्राधान्य',
  privacySecurity: 'गोपनीयता आणि सुरक्षा',
  notificationPreferences: 'सूचना प्राधान्ये',
  allowDirectMessages: 'थेट संदेशांना परवानगी द्या',
  letOthersMessage: 'इतर वापरकर्त्यांना तुम्हाला खाजगी संदेश पाठवण्याची परवानगी द्या',
  likesOnPosts: 'पोस्ट्सवर आवडले',
  commentsOnPosts: 'पोस्ट्सवर टिप्पण्या',
  newFollowers: 'नवीन फॉलोअर्स',
  mentions: 'उल्लेख',
  save: 'सेव्ह करा',
  deleteAccount: 'खाते हटवा',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'जेव्हा कोणीतरी सूचना मिळवा',
  likesYourPosts: 'तुमच्या पोस्ट्स आवडतात',
  commentsOnYourPosts: 'तुमच्या पोस्ट्सवर टिप्पणी करतात',
  followsYou: 'तुम्हाला फॉलो करतात',
  mentionsYou: 'तुमचा उल्लेख करतात',
  chooseNotifications: 'तुम्हाला कोणत्या सूचना मिळवायच्या आहेत ते निवडा',
  controlWhoInteracts: 'तुमच्याशी कोण संवाद साधू शकते ते नियंत्रित करा',
  manageAccountInfo: 'तुमची खाते माहिती आणि प्राधान्ये व्यवस्थापित करा',
  emailCannotBeChanged: 'सुरक्षा कारणांसाठी ईमेल बदलला जाऊ शकत नाही',
  
  // Common
  loading: 'लोड होत आहे...',
  cancel: 'रद्द करा',
  update: 'अपडेट करा',
  submit: 'सबमिट करा',
  back: 'मागे',
  next: 'पुढे',
  previous: 'मागील',
  online: 'ऑनलाइन',
  offline: 'ऑफलाइन',
  
  // Profile
  editProfile: 'प्रोफाइल संपादित करा',
  noBioYet: 'अद्याप बायो नाही।',
  followers: 'फॉलोअर्स',
  following: 'फॉलोइंग',
  recentActivity: 'अलीकडील क्रियाकलाप',
  noPostsYet: 'अद्याप पोस्ट्स नाहीत',
  shareFirstPost: 'तुमची पहिली पोस्ट शेअर करा!',
  bio: 'बायो',
  dateOfBirth: 'जन्मतारीख',
  follow: 'फॉलो करा',
  unfollow: 'अनफॉलो करा',
  
  // Search
  discover: 'शोधा',
  findPeopleStories: 'तुमच्यासाठी महत्त्वाच्या लोक, कथा आणि कल्पना शोधा',
  searchByName: 'नाव, शीर्षक किंवा #टॅग द्वारे शोधा...',
  searchResults: 'शोध परिणाम',
  noResultsFound: 'कोणतेही परिणाम सापडले नाहीत',
  peopleFound: 'लोक सापडले',
  
  // Settings - Additional keys
  enterDisplayName: 'तुमचे प्रदर्शन नाव प्रविष्ट करा',
  saving: 'सेव्ह करत आहे...',
  confirmDeleteAccount: 'तुम्हाला खात्री आहे की तुम्ही तुमचे खाते हटवू इच्छिता? हे पूर्ववत केले जाऊ शकत नाही।',
  accountDeletedSuccessfully: 'खाते यशस्वीरित्या हटवले गेले।',
  errorDeletingAccount: 'खाते हटवताना त्रुटी। कृपया पुन्हा प्रयत्न करा।',
  settingsSavedSuccessfully: 'सेटिंग्ज यशस्वीरित्या सेव्ह झाल्या!',
  failedToSaveSettings: 'सेटिंग्ज सेव्ह करण्यात अयशस्वी। कृपया पुन्हा प्रयत्न करा।',
  
  // Form component
  pleaseSignInToCreate: 'पोस्ट तयार करण्यासाठी साइन इन करा।',
  titleRequired: 'पोस्ट प्रकाशित करण्यासाठी शीर्षक आवश्यक आहे।',
  contentRequired: 'पोस्ट प्रकाशित करण्यासाठी कथा सामग्री आवश्यक आहे।',
  contentTooShort: 'कथा सामग्री किमान 10 वर्णांची असावी।',
  postUpdatedSuccessfully: 'पोस्ट यशस्वीरित्या अपडेट झाली!',
  postPublishedSuccessfully: 'पोस्ट यशस्वीरित्या प्रकाशित झाली!',
  pleaseSignInToCreateBlogs: 'तुमचे स्वतःचे IdeaFlux ब्लॉग तयार करण्यासाठी साइन इन करा।',
  enterEngagingTitle: 'आकर्षक शीर्षक प्रविष्ट करा...',
  story: 'कथा',
  writeYourMasterpiece: 'तुमची उत्कृष्ट कृती लिहा...',
  addTags: 'टॅग्ज जोडा...',
  add: 'जोडा',
  publishPost: 'पोस्ट प्रकाशित करा',
  
  // Post component
  linkCopiedToClipboard: 'लिंक क्लिपबोर्डवर कॉपी केली! शेअर काउंट अपडेट केले।',
  youAndOthers: 'तुम्ही आणि {{count}} इतर',
  unknownUser: 'अज्ञात वापरकर्ता',
  noImage: 'प्रतिमा नाही',
  deletePost: 'पोस्ट हटवा',
  confirmDeletePost: 'तुम्हाला खात्री आहे की तुम्ही ही पोस्ट हटवू इच्छिता?',
};
